export default __webpack_public_path__ + "static/media/emailsignupdesktop.e859a6d7.png";